var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSidebarActions } from '../../service/sidebar-service/hooks';
import { sidebarServiceIsOpenMenuSelector } from '../../service/sidebar-service/service-store/selectors';
import { useSidebarStore } from '../../service/sidebar-service/service-store/service-store';
import { profileServiceAvailablePagesSelector } from 'common/services/profile-service/service-store/selectors';
import { useProfileStore } from 'common/services/profile-service/service-store/service-store';
import { Box } from 'ui-kit/box';
import { EnvironmentName } from 'ui-kit/environment';
import { Navigation } from '../navigation';
import { Header, MobileMenuOverlay, Footer, RoutesObserver } from './modules';
import styles from './mobile-menu.module.scss';
export var MobileMenu = function () {
    var setIsOpenMenu = useSidebarActions().setIsOpenMenu;
    var isOpen = useSidebarStore(sidebarServiceIsOpenMenuSelector);
    var availablePages = useProfileStore(profileServiceAvailablePagesSelector);
    var closeModalHandler = useCallback(function () {
        setIsOpenMenu(false);
    }, [setIsOpenMenu]);
    return (_jsxs(EnvironmentName, __assign({ name: "mobile-menu" }, { children: [_jsxs(MobileMenuOverlay, __assign({ pt: 12, display: "flex", direction: "column", isOpen: isOpen, onClose: closeModalHandler }, { children: [_jsx(Box, __assign({ className: styles.headerWrapper, px: 8, display: "block" }, { children: _jsx(Header, {}) })), _jsx(Navigation, { isNotDesktop: true, className: styles.navigationContainer }), availablePages && availablePages.isSupportRequestsEnabled ? (_jsx(Box, __assign({ className: styles.footerWrapper, px: 16, py: 8 }, { children: _jsx(Footer, { className: styles.footerAction }) }))) : null] })), _jsx(RoutesObserver, { onClose: closeModalHandler })] })));
};
